export default "__VITE_ASSET__D_z2Ro9c__"